import { jsx as _jsx } from "react/jsx-runtime";
import { CharacterListEntry } from './CharacterListEntry.js';
import { IconList } from './IconList.js';
export function CharacterList(props) {
    const { title, characters, onClick, button, dense } = props;
    return (_jsx(IconList, { title: title, dense: dense, children: characters.map((character) => (_jsx(CharacterListEntry, { character: character, onClick: onClick ? () => onClick(character) : undefined, button: button, dense: dense }, character.id))) }));
}
//# sourceMappingURL=CharacterList.js.map